import React, { Fragment } from 'react';
import ReactTooltip from 'react-tooltip';
import Loader from 'src/components/Loader';
import { Trans } from 'react-i18next';
import ColorBar from 'src/components/ColorBar';
import { makeJobUrl } from 'src/routes/routes';
import { useData } from './hooks';
import s from '../Dashboards.styles';

export const FactoryUserDashboardWidget = () => {
  const { jobs, jobsLoading} = useData();
  const WidgetDivFunc = () => {
    if (!jobs || jobs.length === 0) {
      return null;
    }

    return (
      <s.WidgetDiv>
        <ReactTooltip id="FactoryUserDashboardWidget" place="right" />
        {jobs.map(job => {
          return (
            <s.WidgetCard key={job.jobId} factory>
              <s.WidgetCardInnerDiv>
                <s.JobName to={makeJobUrl(job.jobId)}>
                  {job.reportNumber}
                </s.JobName>
                <s.FacilityScoreAndBenchmarking>
                  <Trans>
                    FACTORY_USER_DASHBAORD_FACILITY_SCORE_AND_BENCHMARKING
                  </Trans>
                </s.FacilityScoreAndBenchmarking>
                {(() => {
                    const { score, ratingGrades } = job;

                    if(ratingGrades.length === 0) {
                      return <s.NoRatingDataDiv><s.ErrorIcon name="error" />No Rating Data</s.NoRatingDataDiv>;

                    }
                    const sortedRatingGrades = ratingGrades.sort(rg => rg.min);
                    const ratingGrade = sortedRatingGrades.find(
                      rg => score >= rg.min && score <= rg.max,
                    );
                    const ratingGradeBiggestMax = sortedRatingGrades[sortedRatingGrades.length - 1];

                    return <s.FactoryRatingInfoDiv>
                      <s.RatingGradeSpan
                        style={{
                          background: ratingGrade ? ratingGrade.color : 'black',
                        }}
                      >
                        {ratingGrade ? ratingGrade.name : null}
                      </s.RatingGradeSpan>
                      <s.RatingBarDiv>
                        <s.RatingDataText>
                          {score} <Trans>FACTORY_USER_DASHBAORD_OUT_OF</Trans> 100
                        </s.RatingDataText>
                        <ColorBar
                          data={ratingGrades.map(rg => ({
                            name: rg.name,
                            value:
                            rg.max === ratingGradeBiggestMax.max
                              ? rg.max - rg.min
                              : rg.max - rg.min + 1,
                            color: rg.color,
                          }))}
                          score={score}
                        />
                      </s.RatingBarDiv>
                    </s.FactoryRatingInfoDiv>;
                  })()
                }
              </s.WidgetCardInnerDiv>
              <s.BoxLine />
              <s.WidgetCardInnerDiv flex>
                <s.WidgetCardInnerDivLeft>
                  <s.FindingStatusTitleText>
                    <Trans>FACTORY_USER_DASHBAORD_FINDINGS</Trans>
                  </s.FindingStatusTitleText>
                  {job.findings.map(f => {
                    return (
                      <s.InnerDivRow key={f.id} data-for="FactoryUserDashboardWidget" data-tip={f?.info?.name}>
                        {f?.info?.name}
                      </s.InnerDivRow>
                    );
                  })}
                </s.WidgetCardInnerDivLeft>
                <s.WidgetCardInnerDivRight>
                  <s.FindingStatusTitleText>
                    <Trans>FACTORY_USER_DASHBAORD_STATUS</Trans>
                  </s.FindingStatusTitleText>
                  {job.findings.map(f => {
                    const approvedStatus =
                      f.approvedActionCount === 0
                        ? { zero: true }
                        : { approved: true };
                    const pendingStatus =
                      f.pendingActionCount === 0
                        ? { zero: true }
                        : { pending: true };
                    const rejectedStatus =
                      f.rejectedActionCount === 0
                        ? { zero: true }
                        : { rejected: true };
                    return (
                      <s.InnerDivRow key={f.id}>
                        <s.StatusSpan {...approvedStatus} factory>
                          <s.StatusSvg name={'cap-approved'} />
                          {f.approvedActionCount}
                        </s.StatusSpan>
                        <s.StatusSpan {...pendingStatus} factory>
                          <s.StatusSvg name={'cap-pending'} />
                          {f.pendingActionCount}
                        </s.StatusSpan>
                        <s.StatusSpan {...rejectedStatus} factory>
                          <s.StatusSvg name={'cap-rejected'} />
                          {f.rejectedActionCount}
                        </s.StatusSpan>
                      </s.InnerDivRow>
                    );
                  })}
                </s.WidgetCardInnerDivRight>
              </s.WidgetCardInnerDiv>
            </s.WidgetCard>
          );
        })}
      </s.WidgetDiv>
    );
  };

  return (
    <Fragment>
      <s.DashboardComponent>
        <s.DashboardComponentTitle widget>
          <Trans>FACTORY_USER_DASHBAORD_SUMMARY_INFOMATION</Trans>
        </s.DashboardComponentTitle>
        {jobsLoading ? <Loader /> : WidgetDivFunc()}
      </s.DashboardComponent>
    </Fragment>
  );
};

export default React.memo(FactoryUserDashboardWidget);
